import { pluginFactory } from '@atlaskit/editor-common/utils';
import { aiSmartButtonAPIKey } from './ai-smart-button-api-plugin-key';
import { reducer } from './reducer';
export var createInitialState = function createInitialState() {
  return {};
};
var _pluginFactory = pluginFactory(aiSmartButtonAPIKey, reducer, {}),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand,
  getPluginState = _pluginFactory.getPluginState;
export { createPluginState, createCommand, getPluginState };